export const mediadata = [
    {
        "id": 1,
        "image": require("../../assets/media articles/israel.jpg"),
        "title": "Indian Jews In Israel: It Wasn't The Promised Land",
        "description": "Seventy-three years ago, Israel made a promise to India’s Jews it didn’t keep. It invited them to ‘return to the promised land’ but went back on its word. Sometimes with heart-wrenching consequences" ,
        "publisher": "Live History India",
        "article": "https://www.livehistoryindia.com/story/intersections/indian-jews-in-israel"
    }
]
